import { format } from 'date-fns';

export const dateFormat = date => format(date, 'dd/MM/yyyy');